var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.title)?_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-icon',_vm._g(_vm._b({staticClass:"mt-2",attrs:{"slot":"activator","large":"","color":"sleep"},slot:"activator"},'v-icon',attrs,false),on),[_vm._v(" mdi-account-tie ")])]}}],null,false,4067264191)},[_c('span',[_vm._v(" "+_vm._s(_vm.title)+" ")])]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }